import React from "react";

export const matildeAnarayPublishedAt = (
  <span className="white">
    Revista <i>Vida</i> No. 39, 1950. <i>Cuentos Tricolores</i>, 1967
  </span>
);
